export const CONSONANT_VOWEL_PAIRS_P_B = [

    // ㅂ
    {
        id: 1,
        korean: "바",
        english: "pa/ba",

    },
    {
        id: 2,
        korean: "베",
        english: "pe/be",

    },
    {
        id: 3,
        korean: "비",
        english: "pi/bi",

    },
    {
        id: 4,
        korean: "보",
        english: "po/bo",

    },
    {
        id: 5,
        korean: "브",
        english: "peu/beu",

    },
    {
        id: 6,
        korean: "버",
        english: "peo/beo",

    },
    {
        id: 7,
        korean: "뱌",
        english: "pya/bya",

    },
    {
        id: 8,
        korean: "배",
        english: "pae/bae",

    },
    {
        id: 9,
        korean: "볘",
        english: "pye/bye",

    },
    {
        id: 10,
        korean: "뵤",
        english: "pyo/byo",

    },
    {
        id: 11,
        korean: "벼",
        english: "pyoe,byoe",

    },
    {
        id: 12,
        korean: "뷰",
        english: "pyu/byu",

        

    },

    {
        id: 13,
        korean: "반",
        english: "pan/ban",

        

    },
    {
        id: 14,
        korean: "박",
        english: "pak/bak",

        

    },
    {
        id: 15,
        korean: "빔",
        english: "pim/bim",
        

    },
    {
        id: 16,
        korean: "밧",
        english: "pat/bat",
        

    },
    {
        id: 17,
        korean: "밯",
        english: "pah/bah",
        

    },
    {
        id: 18,
        korean: "법",
        english: "peob/beob",
        

    },
          {
        id: 19,
        korean: "볠",
        english: "pyel/byel",
        

    },
    {
        id: 20,
        korean: "밪",
        english: "pat/bat",
        

    },
    {
        id: 21,
        korean: "밲",
        english: "paekk/baekk",
        

    },
    {
        id: 22,
        korean: "밴",
        english: "paen/baen",
        

    },
    {
        id: 23,
        korean: "븨",
        english: "pui/bui",
        

    },
    {
        id: 24,
        korean: "붜",
        english: "pwo/bwo",
        

    },

    {
        id: 25,
        korean: "뱥",
        english: "pyat/byat",
        

    },
    {
        id: 26,
        korean: "붜",
        english: "pwa/bwa",
        

    },
    {
        id: 27,
        korean: "방",
        english: "pang/bang",
        
    },
    {
        id: 28,
        korean: "봌",
        english: "pok/bok",
        
    },
    {
        id: 29,
        korean: "밮",
        english: "pap/bap",
        
    },
    {
        id: 30,
        korean: "밥",
        english: "pap/bap",
        
    }
    
];

